/* eslint-disable no-restricted-syntax */
import { getToken } from "../utils/authUtils";
import { parseJSON } from "./parseJSON";

const urlBase = `${process.env.API_URL}/subclientInactivo`;
const readUrl = (url = "") => `${urlBase}${url}`;

export const fetchSubclientesInactivos = async (params) => {
  const auth = `Bearer ${getToken()}`;

  const query = new URLSearchParams(params);

  // Obtén el valor del parámetro "sort"
  const sortParam = query.get("sort");
  if (sortParam) {
    // Agrega los nuevos parámetros "orderBy" y "orderType"

    query.set("orderBy", sortParam);
    query.set("orderType", "ASC");
  }
  // Verifica si el parámetro "sort" tiene un signo menos (-)
  if (sortParam && sortParam.startsWith("-")) {
    // Remueve el signo menos (-) y obtén el valor de "sort"
    const sortValue = sortParam.substring(1);

    // Agrega los nuevos parámetros "orderBy" y "orderType"
    query.set("orderBy", sortValue);
    query.set("orderType", "DESC");
  }
  query.delete("sort");

  let res = await fetch(readUrl(`?${query.toString()}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const patchSubclientesInactivos = async (itemId) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`/${itemId}`), {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  // Si es 400, parseamos el JSON pero devolvemos el error sin lanzar excepción
  if (res.status === 400) {
    const errorData = await res.json();
    return {
      success: false,
      status: 400,
      message: errorData.message || "Error al activar subcliente",
      errors: errorData.errors || [],
      result: errorData,
    };
  }

  res = await parseJSON(res);

  return res;
};
